// U5's webinarChanges switch as the pages see it (infrastructure-
// specification, Rollout). Read once when the app starts; off until read and
// off if it cannot be read, so the app never offers a change, cancel, delete,
// the edit page or the admin Webinars tab the API would refuse.
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { useApi } from '../app/api-context';

const WebinarChangesContext = createContext(false);

export function WebinarChangesSwitchProvider(props: { children: ReactNode }) {
  const api = useApi();
  const [isOn, setIsOn] = useState(false);
  useEffect(() => {
    let isCurrent = true;
    api
      .get<{ webinarChanges?: unknown }>('/api/v1/public/features')
      .then((features) => {
        if (isCurrent) setIsOn(features.webinarChanges === true);
      })
      // Unreadable switches keep the changes hidden; nothing started fails.
      .catch(() => undefined);
    return () => {
      isCurrent = false;
    };
  }, [api]);
  return (
    <WebinarChangesContext.Provider value={isOn}>{props.children}</WebinarChangesContext.Provider>
  );
}

// A fixed switch, for tests and previews.
export function FixedWebinarChangesSwitch(props: { isOn: boolean; children: ReactNode }) {
  return (
    <WebinarChangesContext.Provider value={props.isOn}>
      {props.children}
    </WebinarChangesContext.Provider>
  );
}

export const useIsWebinarChangesOn = () => useContext(WebinarChangesContext);
